import { io } from 'socket.io-client';
import { constant } from '../constant';

/**
 * Socket.io singleton.
 *
 * Connects on demand using the JWT in localStorage. The server lives at
 * the same origin as the REST API but at the root path (Socket.io
 * multiplexes its own /socket.io route automatically).
 */

let socket = null;

function deriveSocketUrl() {
  // constant.baseUrl typically ends with '/api/' — strip the trailing
  // /api so socket.io connects to the bare server origin.
  const base = constant.baseUrl || '';
  return base.replace(/\/api\/?$/, '').replace(/\/$/, '');
}

export function connectSocket() {
  if (socket && socket.connected) return socket;
  if (socket) {
    socket.connect();
    return socket;
  }

  const token = localStorage.getItem('token');
  if (!token) return null;

  socket = io(deriveSocketUrl(), {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    transports: ['websocket', 'polling'],
  });

  socket.on('connect', () => {
    console.log('🔌 socket connected', socket.id);
  });
  socket.on('disconnect', (reason) => {
    console.log('🔌 socket disconnected', reason);
  });
  socket.on('connect_error', (err) => {
    console.warn('🔌 socket connect_error', err.message);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket() {
  return socket;
}

export default { connectSocket, disconnectSocket, getSocket };
